﻿//import API from './api';

//const api = new API({ url: '/Home' });

import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalDoNotCall`,
  scopes: ExtHubRequest,
});

api.createEntities([{ name: 'CheckPhoneNumber' }]);

const CheckPhoneNumber = (body) => api.endpoints.CheckPhoneNumber.post(body);

export { CheckPhoneNumber };
